var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"courseBox"},[_c('router-view'),_c('courseList',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }